import { DDSBodyText, DDSLabelText } from "@web-monorepo/dds";
import { Link } from "react-router-dom";
import styles from "./ExperienceCard.module.css";

function getSrcSet(src: string) {
  if (!src) {
    return "";
  }
  return `${src} 1x, ${src.replace(".png", "@2x.png")} 2x, ${src.replace(".png", "@3x.png")} 3x`;
}

type ExperienceCardProps = {
  href: string;
  mojo: string;
  title: string;
  description: string;
};

export default function ExperienceCard({ href, mojo, title, description }: ExperienceCardProps) {
  return (
    <Link to={href} className={styles.card}>
      <div>
        <img srcSet={getSrcSet(mojo)} src={mojo} alt="" className={styles.img} />
      </div>
      <div className={styles.titleWrap}>
        <DDSLabelText as="h4" level="md" className={styles.title}>
          {title}
        </DDSLabelText>
        <DDSBodyText level="md" variant="tertiary" className={styles.description}>
          {description}
        </DDSBodyText>
      </div>
    </Link>
  );
}
